import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M145.1 12.1c4 0 7.7 1.5 10.6 4.1 2.8 2.6 4.4 6.1 4.4 9.8v27.7h15c4 0 7.7 1.5 10.6 4.1 2.8 2.6 4.4 6.2 4.4 9.8V174c0 3.7-1.6 7.2-4.4 9.8S179 188 175 188H25c-4 0-7.7-1.5-10.6-4.1S10 177.8 10 174V26c0-3.7 1.6-7.2 4.4-9.8S21 12 25 12h120.1v.1zm15 138.6v16.2c0 1.7.7 3.4 2 4.6 1.3 1.3 2.9 2.1 4.8 2.2h.7c1.9 0 3.7-.6 5-1.8 1.4-1.2 2.2-2.7 2.4-4.5V72.1c0-1.3-.5-2.4-1.5-3.2s-2.2-1.4-3.6-1.4h-10.1v83.1h.3zm-37.5-13.8H47.5c-1.9 0-3.8.7-5.1 1.9-1.4 1.3-2.2 2.9-2.3 4.7-.1 1.8.5 3.6 1.8 4.8 1.3 1.4 3 2.2 4.9 2.4h75.8c2 0 3.9-.7 5.3-2s2.2-3 2.2-4.9c0-1.9-.8-3.6-2.2-4.9-1.5-1.3-3.3-2-5.3-2zm0-37H47.5c-1.9 0-3.8.7-5.1 1.9-1.4 1.3-2.2 2.9-2.3 4.7-.1 1.8.5 3.6 1.8 4.8 1.3 1.4 3 2.2 4.9 2.4h75.8c2 0 3.9-.7 5.3-2s2.2-3 2.2-4.9-.8-3.6-2.2-4.9c-1.5-1.3-3.3-2-5.3-2zM90 49.1H45c-1.3 0-2.4.4-3.4 1.2s-1.5 1.8-1.7 2.9v19c0 1.2.4 2.2 1.3 3 .8.8 1.9 1.4 3.1 1.6H90c1.3 0 2.4-.4 3.4-1.2.9-.7 1.5-1.8 1.7-2.9v-19c0-.6-.1-1.3-.4-1.8-.2-.5-.6-1-1-1.5-.4-.4-1-.7-1.7-1-.6-.2-1.3-.3-2-.3z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}